import ReactDOM from "react-dom/client";
import './Utils/firebaseConfig';

import App from "./App";
import "./index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);
root.render(
  // <StrictMode>
    <App />
  // </StrictMode>
);

serviceWorkerRegistration.register();
